jQuery(function($){
  var swiper = new Swiper('.profile-slider__slider', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 16,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
      }
    },
  });
  $('.profile-slider__slide-img').on('click', function(){
    $(this).parent().addClass('m--active');
  });
  $('.profile-slider__slide-toggle').on('click', function(){
    $(this).parent().toggleClass('m--active');
  });
});
